import React from 'react';

const FlexBasisFull: React.FC = () => {
  return <div className='basis-full'></div>;
};

export default FlexBasisFull;
